import React from "react";
import {Nav} from "react-bootstrap";
import './css/Sidebar.css'
//import { useState } from "react";

//const basedir = `${process.env.PUBLIC_URL}`;

const Sidebar = props => {
    const style={
        height: '100%'
    };

    return (
        <>

        <Nav className="col-md-12 d-none d-md-block sidebar"
            style={style}
            activeKey={props.mode}
            onSelect={selectedKey => { props.handleclick(selectedKey)}}
        >
            <Nav.Item><Nav.Link eventKey='MODELS'>Models</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="LIFT">Lift</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="CABIN">Cabin</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="INFO">Info</Nav.Link></Nav.Item>
        </Nav>
        </>
    );
};

export default Sidebar